import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/chosenForYouMlTags/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showChosenForYouMlTagsSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => !!(testReady && show));

export { showChosenForYouMlTagsSelector };
